module.exports = __webpack_public_path__ + "blissweb-md.0410148365f5ad00d7ab.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BlissWeb-Md/blissweb-md.eot
// module id = 155
// module chunks = 5